<template>
  <div>
    <loading
      :active.sync="fullscreenLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
    ></loading>
    <!-- CABECERA:-->
    <base-header class="pb-2" type="">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">{{ totalActivos }} EPIS</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <ol class="breadcrumb breadcrumb-links">
              <li class="breadcrumb-item">
                <router-link to="/"><i class="fas fa-home"></i></router-link>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Gestión de Activos</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">EPIs</li>
            </ol>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="sm"
            type="neutral"
            @click="clearSearchState"
            :loading="loading"
          >
            Limpiar filtros
          </base-button>
          <base-button
            size="sm"
            type="neutral"
            @click="fetchDataAndExportToExcel()"
            :loading="loading"
            >Exportar a Excel</base-button>

          <!-- Botón para activar modo multi-planta (solo visible para usuarios autorizados) -->
          <base-button
            v-if="puedeVerMultiPlantas"
            size="sm"
            :type="modoMultiPlanta ? 'success' : 'neutral'"
            @click="toggleMultiPlantMode"
            :loading="loading"
          >
            <i :class="modoMultiPlanta ? 'fas fa-check-circle' : 'fas fa-building'" class="mr-1"></i>
            {{ modoMultiPlanta ? 'Modo Multi-Planta' : 'Activar Multi-Planta' }}
          </base-button>
        </div>
      </div>
      <!-- CARDS CON LOS ESTADOS DE LOS EQUIPOS:-->
      <div class="kpi-container">
        <div
          class="kpi-item"
          @click="getList('Fin vida útil')"
          style="cursor: pointer"
        >
          <stats-card-img
            title="Fin Vida Útil"
            type="gradient-red"
            :sub-title="totalFinVidaUtilAlcanzada ? totalFinVidaUtilAlcanzada.toString() : '0'"
            img="/img/ios-fin-vida.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                {{
                  totalFinVidaUtilAlcanzada
                    ? Math.floor((totalFinVidaUtilAlcanzada * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>

        <div
          class="kpi-item"
          @click="getList('No apto')"
          style="cursor: pointer"
        >
          <!-- Contenido del KPI 'No Aptos' -->
          <stats-card-img
            title="No aptos"
            type="gradient-red"
            :sub-title="totalNoAptos ? totalNoAptos.toString() : '0'"
            img="/img/ios-alert.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                {{
                  totalNoAptos
                    ? Math.floor((totalNoAptos * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>

        <div
          class="kpi-item"
          @click="getList('Caducado')"
          style="cursor: pointer"
        >
          <!-- Contenido del KPI 'Revisión Caducada' -->
          <stats-card-img
            title="Revisión caducada"
            type="gradient-orange"
            :sub-title="totalCaducados ? totalCaducados.toString() : '0'"
            img="/img/ios-time.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                {{
                  totalCaducados
                    ? Math.floor((totalCaducados * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>

        <div
          class="kpi-item"
          @click="getList('Prox_Rev')"
          style="cursor: pointer"
        >
          <!-- Contenido del KPI 'Revisión Próxima' -->
          <stats-card-img
            title="Revisión próxima"
            type="gradient-green"
            :sub-title="totalCaducan ? totalCaducan.toString() : '0'"
            img="/img/ios-time-blue.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                {{
                  totalCaducan
                    ? Math.floor((totalCaducan * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">en 3 meses</span>
            </template>
          </stats-card-img>
        </div>

        <div
          class="kpi-item"
          @click="getList('Apto a vigilar')"
          style="cursor: pointer"
        >
          <stats-card-img
            title="Aptos a vigilar"
            type="gradient-red"
            :sub-title="
              totalAptosAVigilar ? totalAptosAVigilar.toString() : '0'
            "
            img="/img/ios-checkmark-orange.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                {{
                  totalAptosAVigilar
                    ? Math.floor((totalAptosAVigilar * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>

        <div class="kpi-item" @click="getList('Apto')" style="cursor: pointer">
          <!-- Contenido del KPI 'Aptos' -->
          <stats-card-img
            title="Aptos"
            type="gradient-green"
            :sub-title="totalAptos ? totalAptos.toString() : '0'"
            img="/img/ios-checkmark-circle.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">
                {{
                  totalAptos
                    ? Math.floor((totalAptos * 100) / totalActivos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los equipos</span>
            </template>
          </stats-card-img>
        </div>
      </div>
      
      <!-- Selector múltiple de plantas (solo visible cuando modo multi-planta está activo) -->
      <div v-if="modoMultiPlanta && puedeVerMultiPlantas" class="row mt-3 mb-3">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-md-4">
                  <label class="form-control-label">
                    <i class="fas fa-building mr-2"></i>
                    <strong>Seleccionar Plantas:</strong>
                  </label>
                </div>
                <div class="col-md-6">
                  <el-select
                    v-model="plantasSeleccionadas"
                    multiple
                    collapse-tags
                    :max-collapse-tags="2"
                    style="width: 100%"
                    placeholder="Selecciona plantas..."
                    filterable
                    clearable
                    @change="manejarCambioPlantas"
                  >
                    <el-option
                      v-if="puedeVerMultiPlantas"
                      key="all"
                      value="all"
                      label="TODAS LAS PLANTAS"
                    >
                      <span class="all-plants-label">TODAS LAS PLANTAS</span>
                    </el-option>
                    <el-option
                      v-for="empresa in availableEmpresas"
                      :key="`empresa-${empresa.id}`"
                      :value="empresa.id"
                      :label="empresa.alias || empresa.nombre || `Planta ${empresa.id}`"
                    >
                      {{ empresa.alias || empresa.nombre || `Planta ${empresa.id}` }}
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-2 text-right">
                  <base-button
                    size="sm"
                    type="warning"
                    @click="toggleMultiPlantMode"
                  >
                    <i class="fas fa-times mr-1"></i>
                    Desactivar
                  </base-button>
                </div>
              </div>
              <div v-if="obtenerInfoPlantasSeleccionadas()" class="row mt-2">
                <div class="col-12">
                  <small class="text-muted">
                    <i class="fas fa-info-circle mr-1"></i>
                    {{ obtenerInfoPlantasSeleccionadas() }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row align-items-center">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0"></h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="sm"
            type="neutral"
            @click="assign()"
            v-if="multipleSelection.length > 0"
          >
            Asignar equipos
          </base-button>
          <base-button
            size="sm"
            type="neutral"
            @click="desAssignPost()"
            v-if="multipleSelection.length > 0 && totalAssigned > 0"
          >
            Devolver equipos
          </base-button>
          <base-button
            size="sm"
            type="neutral"
            @click="revision()"
            v-if="multipleSelection.length > 0 && !isRevisor"
          >
            Solicitar revisión
          </base-button>
          <!-- Funcionalidad masiva temporalmente oculta -->
          <!-- <base-button
            size="sm"
            type="success"
            @click="openBulkRevisionModal"
            v-if="multipleSelection.length > 0 && isRevisor"
          >
            <i class="fas fa-clipboard-check mr-1"></i>
            Revisión Rápida Masiva
          </base-button> -->
          <base-button
            size="sm"
            type="neutral"
            @click="retirar()"
            v-if="multipleSelection.length > 0"
          >
            Retirar equipos
          </base-button>
          <!-- Nuevo botón: Exportar seleccionados -->
          <base-button
            size="sm"
            type="neutral"
            @click="fetchSelectedAndExportToExcel"
            v-if="multipleSelection.length > 0"
            :loading="loading"
          >
            Exportar seleccionados
          </base-button>
        </div>
      </div>
    </base-header>

    <!-- CONTENIDO:-->
    <div class="container-fluid mt-4" v-if="fullscreenLoading == false">
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <div class="p-2">
          <div
            class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            :class="{
              'has-active-filters': !!query || !!estado || !!fdesde || !!fhasta,
            }"
          >
            <!-- BUSCADOR:-->
            <div class="col-md-4">
              <div :class="{ 'has-filter': !!query }">
                <form @submit.prevent>
                  <base-input
                    v-model="query"
                    type="search"
                    prepend-icon="fas fa-search"
                    placeholder="Buscar por marca, modelo, nº serie, usuario..."
                    clearable
                  />
                </form>
              </div>
            </div>
            <!-- FILTROS:-->
            <div class="col-md-8">
              <div class="d-flex justify-content-right justify-content-sm-end">
                <div class="pr-4" :class="{ 'has-filter': !!estado }">
                  <el-select
                    ref="stateSelect"
                    class="select-primary"
                    :class="{ 'is-selected': hasSelectedValue }"
                    v-model="estado"
                    placeholder="Estado"
                    style="width: 100%; height: 46px !important"
                    @change="handleStateChange"
                  >
                    <el-option
                      v-for="item in estados"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <div class="row">
                    <div class="col pr-1" :class="{ 'has-filter': !!fdesde }">
                      <base-input label="">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="configInput"
                          class="form-control datepicker"
                          v-model="fdesde"
                          placeholder="Prox. revisión desde..."
                        >
                        </flat-picker>
                      </base-input>
                    </div>
                    <div class="col pl-0" :class="{ 'has-filter': !!fhasta }">
                      <base-input label="">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="configInput"
                          class="form-control datepicker"
                          v-model="fhasta"
                          placeholder="Prox. revisión hasta..."
                        >
                        </flat-picker>
                      </base-input>
                    </div>
                  </div>
                </div>
                <div
                  class="ml-2 d-flex align-items-center"
                  v-if="hasActiveFilters"
                >
                  <button
                    class="btn clear-filters-btn"
                    @click="clearSearchState"
                    title="Limpiar filtros"
                  >
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- TABLA DE EQUIPOS:-->
          <el-table
            ref="multipleTable"
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="activos"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            empty-text="No hay ningún equipo que cumpla con los requisitos de búsqueda"
            :row-class-name="getRowClass"
          >
            <!-- LOADING-->
            <div slot="empty" v-if="loadingTable">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <el-table-column type="selection" width="40"> </el-table-column>

            <!-- COLUMNA EMPRESA (solo visible cuando modo multi-planta está activo) -->
            <el-table-column
              v-if="modoMultiPlanta"
              label="Planta"
              prop="empresa.data.attributes.alias"
              sortable="custom"
              min-width="120"
            >
              <template v-slot="{ row }">
                <span class="font-weight-bold">{{ row.empresa?.data?.attributes?.alias || row.empresa?.data?.attributes?.nombre || '-' }}</span>
              </template>
            </el-table-column>

            <!-- COLUMNA MODELO -->
            <el-table-column
              label="Modelo"
              prop="modelo.data.attributes.nombre"
              sortable="custom"
              min-width="140"
            >
              <template v-slot="{ row }">
                {{ row.modelo.data.attributes.nombre + "-" }}
                <b>{{ row.fabricante.data.attributes.nombre }}</b>
              </template>
            </el-table-column>

            <!-- COLUMNA NUMERO SERIE -->
            <el-table-column
              label="Nº serie"
              prop="numero_serie"
              sortable="custom"
              min-width="90"
            >
              <template v-slot="{ row }">
                <b>{{ row.numero_serie }}</b>
              </template>
            </el-table-column>

            <!--  COLUMNA ICONO ESTADO -->
            <el-table-column 
              label="" 
              width="40" 
              align="center"
            >
              <template v-slot="{ row }">
                <!-- RETIRADO -->
                <div v-if="row.retirado" class="retired-icon">
                  <i
                    class="fas fa-archive"
                    style="color: #666; font-size: 18px"
                  ></i>
                  <span class="badge badge-retired no-strike">RETIRADO</span>
                </div>
                <!-- FIN VIDA ÚTIL ALCANZADA -->
                <img
                  v-else-if="row.fin_vida_util_alcanzada"
                  src="/img/ios-fin-vida.png"
                  style="height: 24px; width: 24px"
                  alt="Fin vida útil"
                  title="Fin vida útil alcanzada"
                />
                <!-- NO APTO -->
                <img
                  v-else-if="
                    row.revisiones.data.length > 0 &&
                    row.revisiones.data[row.revisiones.data.length - 1]
                      .attributes.estado === 'no_apto'
                  "
                  src="/img/ios-alert.png"
                  style="height: 24px; width: 24px"
                />
                <!-- RESTO DE ESTADOS -->
                <img
                  v-else-if="
                    moment(row.fecha_prox_revision).isBefore(
                      new Date().getTime()
                    )
                  "
                  src="/img/ios-time.png"
                  style="height: 24px; width: 24px"
                />
                <img
                  v-else-if="
                    row.revisiones.data.length > 0 &&
                    row.revisiones.data[row.revisiones.data.length - 1]
                      .attributes.estado === 'apto_a_vigilar'
                  "
                  src="/img/ios-checkmark-orange.png"
                  style="height: 24px; width: 24px"
                />

                <img
                  v-else-if="
                    moment()
                      .add(3, 'months')
                      .isSameOrAfter(moment(row.fecha_prox_revision))
                  "
                  src="/img/ios-time-blue.png"
                  style="height: 24px; width: 24px"
                />

                <img
                  v-else-if="
                    row.revisiones.data.length > 0 &&
                    row.revisiones.data[row.revisiones.data.length - 1]
                      .attributes.estado === 'apto'
                  "
                  src="/img/ios-checkmark-circle.png"
                  style="height: 24px; width: 24px"
                />
                <img
                  v-else-if="
                    moment()
                      .add(3, 'months')
                      .isBefore(moment(row.fecha_prox_revision))
                  "
                  src="/img/ios-checkmark-circle.png"
                  style="height: 24px; width: 24px"
                />

                <!--       <img
                  v-else-if="
                    moment(row.fecha_prox_revision).isSameOrAfter(
                      new Date().getTime()
                    )
                  "
                  src="/img/ios-checkmark-circle.png"
                  style="height: 24px; width: 24px"
                /> -->

                <!--     incidencias: {
              estado_incidencia: {
                descripcion: { $eq: "abierta" },
              },
            }, -->
              </template>
            </el-table-column>

            <!-- COLUMNA PROX. REVISION -->
            <el-table-column
              label="Prox. Revisión"
              prop="fecha_prox_revision"
              sortable="custom"
              align="left"
              min-width="120"
            >
              <template v-slot="{ row }">
                <!-- Fin vida útil: mostrar fecha fin vida útil -->
                <template v-if="row.fin_vida_util_alcanzada">
                  <span class="status text-muted">
                    <span class="badge badge-fin-vida-util-inline">Fin vida útil</span>
                    <template v-if="row.fecha_fin_vida_util">
                      <br />{{ moment(row.fecha_fin_vida_util).format("DD/MM/YYYY") }}
                    </template>
                  </span>
                </template>
                <template
                  v-else-if="
                    row.revisiones.data.length > 0 &&
                    row.revisiones.data[row.revisiones.data.length - 1]
                      .attributes.estado === 'no_apto'
                  "
                >
                </template>
                <template v-else>
                  <badge class="badge-dot">
                    <i
                      v-if="
                        moment(row.fecha_prox_revision).isBefore(
                          new Date().getTime()
                        )
                      "
                      class="bg-danger"
                    ></i>
                    <i
                      v-else-if="
                        moment()
                          .add(3, 'months')
                          .isSameOrAfter(moment(row.fecha_prox_revision))
                      "
                      class="bg-warning"
                    ></i>
                    <i
                      v-else-if="
                        moment(row.fecha_prox_revision).isSameOrAfter(
                          new Date().getTime()
                        )
                      "
                      class="bg-success"
                    ></i>
                  </badge>
                  <span class="status"
                    >{{ moment(row.fecha_prox_revision).format("DD/MM/YYYY")
                    }}<br />
                    ({{ moment(row.fecha_prox_revision).fromNow() }})</span
                  >
                </template>
              </template>
            </el-table-column>

            <!-- COLUMNA QR -->
            <el-table-column
              label="QR"
              prop="numero_serie"
              sortable="custom"
              min-width="50"
            >
              <template v-slot="{ row }">
                <b>{{ row.numero_serie_qr }}</b>
              </template>
            </el-table-column>

            <!-- COLUMNA PRECINTO -->
            <el-table-column
              label="Color"
              prop="color_precinto_cliente"
              sortable="custom"
              min-width="50"
              align="center"
            >
              <template v-slot="{ row }">
                <div v-if="row?.empresa?.data?.id === 68" class="d-flex">
                  <!-- Configuración para UBE -->
                  <i
                    class="fa fa-tag"
                    :style="{
                      color: colorMap[row.color_precinto_cliente] || '#ccc',
                      fontSize: '16px',
                    }"
                  ></i>
                  <span class="ml-1">{{
                    row.numero_precinto_cliente || "-"
                  }}</span>
                </div>
                <div
                  v-else
                  class="d-flex justify-content-center align-items-center"
                  style="height: 100%"
                >
                  <!-- Configuración para otras empresas -->
                  <i
                    class="fa fa-tag"
                    :style="{
                      color: getColorByYear(row.fecha_prox_revision),
                      fontSize: '20px',
                    }"
                  ></i>
                </div>
              </template>
            </el-table-column>

            <!-- COLUMNA USUARIO -->
            <el-table-column
              label="Usuario"
              sortable="custom"
              :prop="'usuario.data.attributes.nombre'"
              min-width="120"
            >
              <template v-slot="{ row }">
                <a
                  v-if="row.usuario?.data"
                  :href="'/user-management/edit-user/' + row.usuario.data.id"
                  class="font-weight-bold"
                >
                  <b>{{
                    row.usuario.data.attributes.nombre +
                    " " +
                    row.usuario.data.attributes.apellidos
                  }}</b>
                </a>
              </template>
            </el-table-column>

            <!-- COLUMNA UBICACIÓN -->
            <el-table-column
              label="Ubicación"
              prop="ubicacion"
              sortable="custom"
              min-width="120"
            >
              <template v-slot="{ row }">
                <b>{{ row.ubicacion }}</b>
              </template>
            </el-table-column>

            <!--  COLUMNA ACCIONES -->
            <el-table-column 
              label="Acciones" 
              align="center" 
              min-width="100"
            >
              <template v-slot="{ row }">
                <div class="table-actions d-flex justify-content-center">
                  <base-button
                    outline
                    size="sm"
                    type="primary"
                    @click="viewTipo(row)"
                    class="mx-1"
                  >
                    Ver
                  </base-button>
                  <!-- Devolver button hidden as requested -->
                  <!-- <base-button
                    v-if="row.usuario.data"
                    outline
                    size="sm"
                    type="danger"
                    @click="desAssignOnlyOnePost(row)"
                  >
                    Devolver
                  </base-button> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="row">
            <div class="col-xl-4">
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>

            <div class="col-xl-8">
              <p class="card-category" style="margin-top: 0.5rem">
                Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                {{ total }} registros

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
          </div>

          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </div>
      </card>
    </div>
    <!-- DIALOG ASIGNACIÓN EQUIPOS -->
    <el-dialog
      title="Asignación de equipos"
      :visible.sync="dialogFormVisible"
      width="60%"
    >
      <div class="col-auto">
        <p>Selecciona el usuario al que quieres asignar los equipos:</p>
        <el-select
          style="width: 100%"
          size="large"
          name="usuario"
          v-model="usuarioSeleccionado"
          placeholder="Selecciona el usuario..."
          filterable
        >
          <el-option
            v-for="usuario in available_usuarios"
            :key="usuario.id"
            :value="usuario.id"
            :label="`${usuario.nombre} ${usuario.apellidos}`"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisible = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button
          v-if="usuarioSeleccionado"
          @click="assignPost"
          type="primary"
          >Confirmar</base-button
        >
      </span>
    </el-dialog>

    <!-- DIALOG SOLICITUD REVISIÓN -->
    <el-dialog
      title="Solicitar revisión a Misepis"
      :visible.sync="dialogFormVisibleRev"
      width="60%"
    >
      <div class="col-auto">
        <p>
          Si aceptas se enviará una solicitud para realizar una revisión de los
          equipos seleccionados:
        </p>
        <ul>
          <li
            v-for="equipo in this.multipleSelection"
            :key="equipo.id"
            :value="equipo.id"
          >
            Identificador: <b>{{ equipo.nombre }}</b
            >. Número de serie:
            <b>{{ equipo.numero_serie }}</b>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisibleRev = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button @click="revisionPost" type="primary">Aceptar</base-button>
      </span>
    </el-dialog>

    <!-- DIALOG RETIRAR EQUIPOS -->
    <el-dialog
      title="Retirar equipos"
      :visible.sync="dialogFormVisibleRetirar"
      width="60%"
    >
      <div class="col-auto">
        <p>
          ¿Estas seguro? Los equipos seleccionados se retirarán de la
          circulación y dejarán de ser visibles.
        </p>
        <ul>
          <li
            v-for="equipo in this.multipleSelection"
            :key="equipo.id"
            :value="equipo.id"
          >
            Identificador: <b>{{ equipo.nombre }}</b
            >. Número de serie:
            <b>{{ equipo.numero_serie }}</b>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisibleRetirar = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button @click="retirarPost" type="primary">Retirar</base-button>
      </span>
    </el-dialog>

    <!-- DIALOG PROGRESO EXPORTACIÓN -->
    <el-dialog
      title="Exportando a Excel..."
      :visible.sync="dialogProgressVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="export-progress-container">
        <div class="mb-4">
          <h5 class="text-center">
            <i class="fas fa-file-excel text-success mr-2"></i>
            Procesando exportación...
          </h5>
          <p v-if="exportCurrentPlantName" class="text-center text-muted mt-2">
            Procesando: <strong>{{ exportCurrentPlantName }}</strong>
          </p>
        </div>
        
        <el-progress
          :percentage="exportProgress"
          :status="exportProgress === 100 ? 'success' : 'active'"
          :stroke-width="24"
          :format="formatProgress"
        ></el-progress>
        
        <div class="mt-3 text-center">
          <small class="text-muted">
            {{ exportCurrentPlant }} de {{ exportTotalPlants }} plantas procesadas
          </small>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <base-button 
          v-if="exportProgress === 100"
          @click="dialogProgressVisible = false" 
          type="primary"
        >
          Cerrar
        </base-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { BasePagination } from "@/components/";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Table,
  TableColumn,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
  Progress,
  // Loading
} from "element-ui";
import MultiPlantMixin from "@/mixins/multi-plant-mixin.js";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import { cloneDeep } from "lodash";
import axios from "axios";
import ExcelJS from "exceljs";
import { formatFinVidaUtilValue, formatVidaUtilLabel } from "@/util/vidaUtil";
import { saveAs } from "file-saver";
moment.locale("es");

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

import VueJsonToCsv from "vue-json-to-csv";

export default {
  layout: "DashboardLayout",
  mixins: [MultiPlantMixin],

  components: {
    BasePagination,
    flatPicker,
    Loading,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Progress.name]: Progress,
  },

  data() {
    return {
      query: null,
      activos: [],
      selectedRows: [],
      sort: "fecha_prox_revision",

      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [25, 50, 100, 200],
      },
      multipleSelection: [],
      totalAssigned: 0,
      total: 0,
      loading: false,
      loadingTable: true,
      fullscreenLoading: false,
      loadingColor: "#7f1058",
      loadingBgColor: "#000",
      loadingHeight: 128,
      loadingWidth: 128,
      dialogFormVisible: false,
      dialogFormVisibleRev: false,
      dialogFormVisibleRetirar: false,
      dialogConfirmVisible: false,
      innerVisible: false,
      formLabelWidth: "120px",
      // Propiedades para barra de progreso de exportación
      dialogProgressVisible: false,
      exportProgress: 0,
      exportCurrentPlant: '',
      exportTotalPlants: 0,
      exportCurrentPlantName: '',
      available_usuarios: [],
      usuarioSeleccionado: null,
      fdesde: null,
      fhasta: null,
      estado: null,
      usuario: null,
      estados: [
        "Apto",
        "Apto a vigilar",
        "No apto",
        "Caducado",
        "Con incidencia",
        "Todos",
      ],
      dashboardQuery: false,
      totalFinVidaUtilAlcanzada: 0,
      totalNoAptos: 0,
      totalAptosAVigilar: 0,
      totalIncidencia: 0,
      totalCaducados: 0,
      totalCaducan: 0,
      totalAptos: 0,
      totalActivos: 0,
      configInput: {
        allowInput: true,
        dateFormat: "d-m-Y",
        locale: Spanish, // locale for this instance only
      },
      itemsToExport: [],
      // Variables para modal de revisión
      showRevisionModal: false,
      selectedActivoForRevision: null,
      isSemiAutomaticRevision: false,
      isRevisor: false,
      // Variables para modal de revisión masiva
      showBulkRevisionModal: false,

      labels: {
        /* "subtipo.data.attributes.nombre": { title: "Subtipo" }, */
        "fabricante.data.attributes.nombre": { title: "Fabricante" },
        numero_serie: { title: "Nº serie" },
        fecha_prox_revision: { title: "Prox. Revisión" },
        "empresa.data.attributes.alias": { title: "Planta" },
        nombre: { title: "Nombre" },
        descripcion: { title: "Descripción" },
      },
      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1, //pendiente de enviar
        },
        tipo_notificacion: {
          id: 3, //tipo: revision
        },
        usuario_origen: {
          id: null,
        },
        usuario_destinos: [],
        empresa: {
          id: null,
        },
        activos: {},
      },
      colorMap: {
        AZUL: "#3498DB", // Azul claro
        ROJO: "#E74C3C", // Rojo
        AMARILLO: "#F1C40F", // Amarillo
        MORADO: "#8E44AD", // Morado
        VERDE: "#2ECC71", // Verde
        // Agrega más colores según sea necesario
      },
      hasSelectedValue: false,
    };
  },
  created() {
    this.getUsers();
    this.checkUserRole();
  },
  mounted() {
    const savedState = localStorage.getItem("episSearchState");
    if (savedState) {
      const state = JSON.parse(savedState);
      this.query = state.query;
      this.fdesde = state.fdesde;
      this.fhasta = state.fhasta;
      this.estado = state.estado;
      this.pagination.currentPage = state.currentPage || 1;
      this.pagination.perPage = state.perPage || 25;
      this.sort = state.sort || "fecha_prox_revision";

      // Llama a getList para aplicar los filtros guardados
      this.getList();
    } else if (this.$route.query.filter) {
      this.getList(this.$route.query.filter);
      this.dashboardQuery = true;
    }
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    plantaSelected() {
      return localStorage.getItem("plantaSelected");
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    hasActiveFilters() {
      return !!(this.query || this.estado || this.fdesde || this.fhasta);
    },
  },

  watch: {
    query: {
      handler: "handleQueryChange",
      immediate: true,
    },
    fdesde: {
      handler: "getListDebounced",
      immediate: true,
    },
    fhasta: {
      handler: "getListDebounced",
      immediate: true,
    },
    estado: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },
    
    // Extraer identificador de una URL (último segmento después del último /)
    extractIdentifierFromUrl(input) {
      if (!input) return input;
      
      // Si es una URL de misepis.com/code/, extraer el código después de code/
      if (input.includes('misepis.com/code/')) {
        const codeMatch = input.split('code/').pop().split('/')[0];
        if (codeMatch) {
          console.log(`URL misepis.com detectada: ${input} -> Código extraído: ${codeMatch}`);
          return codeMatch;
        }
      }
      
      // Si es una URL de ssea.es/, extraer el código después de ssea.es/
      if (input.includes('ssea.es/')) {
        const codeMatch = input.split('ssea.es/').pop().split('/')[0];
        if (codeMatch) {
          console.log(`URL ssea.es detectada: ${input} -> Código extraído: ${codeMatch}`);
          return codeMatch;
        }
      }
      
      // Verificar si es una URL (contiene http, https, o múltiples /)
      if (input.includes('http') || input.split('/').length > 2) {
        // Extraer el último segmento después del último /
        const segments = input.split('/');
        const lastSegment = segments[segments.length - 1];
        
        // Si el último segmento está vacío, tomar el penúltimo
        const identifier = lastSegment || segments[segments.length - 2];
        
        console.log(`URL detectada: ${input} -> Identificador extraído: ${identifier}`);
        return identifier;
      }
      
      return input;
    },
    
    // Manejar cambios en el query, procesando URLs si es necesario
    handleQueryChange() {
      if (this.query) {
        const processedQuery = this.extractIdentifierFromUrl(this.query);
        if (processedQuery !== this.query) {
          // Si se procesó una URL, actualizar el query con el identificador extraído
          this.query = processedQuery;
          return; // No llamar a getListDebounced aquí para evitar doble llamada
        }
      }
      this.getListDebounced();
    },
    checkIdRevisor(id) {
      return this.available_usuarios.some(function (gfg) {
        return gfg.id === id;
      });
    },
    assign() {
      this.dialogFormVisible = true;
    },
    revision() {
      this.dialogFormVisibleRev = true;
    },
    retirar() {
      this.dialogFormVisibleRetirar = true;
    },

    clearSearchState() {
      // Elimina el estado guardado en localStorage
      localStorage.removeItem("episSearchState");

      // Restablece las variables de filtro a sus valores iniciales
      this.query = null;
      this.fdesde = null;
      this.fhasta = null;
      this.estado = null;
      this.pagination.currentPage = 1;
      this.pagination.perPage = 25;
      this.multipleSelection = [];

      // Vuelve a cargar la lista con filtros vacíos
      this.getList();
    },

    async assignPost() {
      this.fullscreenLoading = true;
      for (const element of this.multipleSelection) {
        var el = element;
        el.usuario = this.usuarioSeleccionado;
        await this.$store.dispatch("activos/update", el);
      }
      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success");
    },
    async revisionPost() {
      let html_activos = "<ul>";
      for (const activo of this.multipleSelection) {
        html_activos =
          html_activos +
          "<li> Identificador: <b>" +
          activo.nombre +
          "</b>. Número de serie: <b>" +
          activo.numero_serie +
          "</b></li>";
      }
      html_activos = html_activos + "</ul>";

      console.log(html_activos);

      this.notificacion.activos = html_activos;
      // this.notificacion.activos = this.multipleSelection;
      console.log("NOTIFICACIÓN:");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "La solicitud se ha enviado correctamente.",
        });
        this.dialogFormVisibleRev = false;
        //this.$router.go(0);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },
    async retirarPost() {
      try {
        this.fullscreenLoading = true;

        // Cerrar el modal antes de realizar las operaciones
        this.dialogFormVisibleRetirar = false;

        // Realizar la operación de retiro para cada elemento seleccionado
        for (const element of this.multipleSelection) {
          var el = element;
          el.retirado = 1;
          await this.$store.dispatch("activos/update", el);
        }

        // Mostrar un mensaje de éxito
        this.showSwal("success_retirados");
      } catch (error) {
        console.error("Error al retirar equipos:", error);
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal al retirar los equipos.",
        });
      } finally {
        // Asegúrate de que el loader se detenga siempre
        this.fullscreenLoading = false;
      }
    },
    getColorByYear(fechaRevision) {
      if (!fechaRevision) return "#ccc"; // Color por defecto si no hay fecha

      // Obtiene el último dígito del año
      const year = new Date(fechaRevision).getFullYear();
      const lastDigit = year % 10;

      // Asocia colores según el último dígito
      const colorMapByYear = {
        1: "#F1C40F", // Amarillo
        2: "#2ECC71", // Verde
        3: "#E67E22", // Naranja
        4: "#3498DB", // Azul
        5: "#E74C3C", // Rojo
        6: "#F1C40F", // Amarillo
        7: "#2ECC71", // Verde
        8: "#E67E22", // Naranja
        9: "#3498DB", // Azul
        0: "#E74C3C", // Rojo
      };

      return colorMapByYear[lastDigit] || "#ccc"; // Devuelve el color asociado
    },

    async desAssignPost() {
      this.fullscreenLoading = true;
      for (const element of this.multipleSelection) {
        var el = element;
        el.usuario = null;
        await this.$store.dispatch("activos/update", el);
      }
      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success_devueltos");
    },

    async desAssignOnlyOnePost(el) {
      this.fullscreenLoading = true;

      el.usuario = null;
      await this.$store.dispatch("activos/update", el);

      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success_devueltos");
    },

    checkIfSomeOneIsAssigned() {
      let isAssigned = 0;
      for (const element of this.multipleSelection) {
        console.log(element.usuario.data);
        if (element.usuario.data != null) isAssigned++;
      }
      this.totalAssigned = isAssigned;
    },

    flattenObject(obj) {
      let flattenKeys = {};
      for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          // flattenKeys[i] = obj[i];
          let flatObject = this.flattenObject(obj[i]);
          for (let j in flatObject) {
            if (!flatObject.hasOwnProperty(j)) continue;
            flattenKeys[i + "." + j] = flatObject[j];
          }
        } else {
          flattenKeys[i] = obj[i];
        }
      }
      return flattenKeys;
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkIfSomeOneIsAssigned();
    },
    getListDebounced: _.debounce(function () {
      try {
        if (!this.dashboardQuery) this.getList();
      } catch (error) {
        this.refreshPage();
      }
    }, 300),
    refreshPage() {
      console.log("refreshPage");
      this.dashboardQuery = false;
      location.reload(); // Reloads the current page
    },

    async getList(estado_kpi) {
      // Guarda el estado actual de la búsqueda en localStorage
      const searchState = {
        query: this.query,
        fdesde: this.fdesde,
        fhasta: this.fhasta,
        estado: this.estado,
        currentPage: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        sort: this.sort,
      };
      localStorage.setItem("episSearchState", JSON.stringify(searchState));
      var planta = localStorage.getItem("plantaSelected");

      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];
      console.log(profile);
      this.user = profile; // Asegurar que el mixin tenga acceso al usuario
      var empresas = [];

      // Check if user belongs to Salvador Seguridad and has 'all' selected
      const perteneceSalvador = profile.empresas.some(
        empresa => empresa.id_cliente_erp === "00001001"
      );
      
      if (perteneceSalvador && planta === 'all') {
        // Don't apply empresa filter when 'all' is selected
        empresas = [];
      } else if (planta >= 0) {
        empresas = [planta];
      } else {
        profile.empresas.forEach((element) => {
          empresas.push(element.id);
        });
      }

      this.notificacion.empresa.id = planta;
      if (this.sort.includes("data.attributes.")) {
        this.sort = this.sort.replace("data.attributes.", "");
      }

      // Crear filtros base para la consulta
      var filters = {
        $and: [
          // Only add empresa filter if empresas array is not empty
          ...(empresas.length > 0 ? [{
            empresa: {
              id: { $in: empresas },
            },
          }] : []),
          {
            $or: [
              { retirado: 0 }, // Equipos con 'retirado' igual a 0
              { retirado: { $null: true } }, // Equipos con 'retirado' igual a null
            ],
          },
          // Incluir también equipos con fin_vida_util_alcanzada (aparecen en EPIs y en Fin Vida Útil)
          {
            modelo: {
              division: {
                id: { $eq: 1 },
              },
            },
          },
          { $or: [] },
        ],
      };

      // Añadir búsqueda por 'query' si está presente
      if (this.query) {
        // Asegurarse de que existe la clave "$or"
        const queryFilter = {
          $or: [
            { subtipo: { nombre: { $containsi: this.query } } },
            { fabricante: { nombre: { $containsi: this.query } } },
            { modelo: { nombre: { $containsi: this.query } } },
            { numero_serie: { $containsi: this.query } },
            { numero_serie_qr: { $containsi: this.query } },
            { ubicacion: { $containsi: this.query } },
            { usuario: { username: { $containsi: this.query } } },
            { usuario: { nombre: { $containsi: this.query } } },
            { usuario: { apellidos: { $containsi: this.query } } },
          ],
        };

        // Asegurarse de que $and existe
        if (!filters["$and"]) {
          filters["$and"] = [];
        }

        // Añadir el filtro de búsqueda al final
        filters["$and"].push(queryFilter);
      }

      // Añadir filtros por fecha si están presentes
      if (this.fdesde) {
        var newdate = this.fdesde.split("-").reverse().join("-");
        filters["$and"].push({
          fecha_prox_revision: { $gt: newdate },
        });
      }

      if (this.fhasta) {
        var newdate = this.fhasta.split("-").reverse().join("-");
        filters["$and"].push({
          fecha_prox_revision: { $lt: newdate },
        });
      }

      // Añadir filtros basados en el estado especificado
      if (estado_kpi) {
        switch (estado_kpi) {
          case "Fin vida útil":
            filters["$and"].push({
              fin_vida_util_alcanzada: true,
            });
            break;

          case "Apto":
            filters["$and"].push({
              revisiones: {
                active: true,
                estado: { $eq: "apto" },
              },
              fecha_prox_revision: { $gte: new Date().toISOString() },
            });
            break;

          case "Apto a vigilar":
            filters["$and"].push({
              revisiones: {
                active: true,
                estado: { $eq: "apto_a_vigilar" },
              },
              fecha_prox_revision: { $gte: new Date().toISOString() },
            });
            break;

          case "No apto":
            filters["$and"].push({
              revisiones: {
                active: true,
                estado: { $eq: "no_apto" },
              },
            });
            break;

          case "Caducado":
            filters["$and"].push({
              fecha_prox_revision: { $lte: new Date().toISOString() },
            });
            break;

          case "Con incidencia":
            filters["$and"].push({
              incidencias: {
                estado_incidencia: {
                  descripcion: { $eq: "abierta" },
                },
              },
            });
            break;

          case "Prox_Rev":
            filters["$and"].push(
              { fecha_prox_revision: { $gt: new Date().toISOString() } },
              {
                fecha_prox_revision: {
                  $lt: moment(new Date()).add(3, "months").toISOString(),
                },
              }
            );
            break;

          default:
            break;
        }
      }

      // Realizar la consulta con los filtros preparados
      if (this.estado) {
        switch (this.estado) {
          case "Fin vida útil":
            filters["$and"].push({
              fin_vida_util_alcanzada: true,
            });
            break;

          case "Apto":
            filters["$and"].push({
              revisiones: {
                active: true,
                estado: { $eq: "apto" },
              },
              fecha_prox_revision: { $gte: new Date().toISOString() },
            });
            break;

          case "Apto a vigilar":
            filters["$and"].push({
              revisiones: {
                active: true,
                estado: { $eq: "apto_a_vigilar" },
              },
              fecha_prox_revision: { $gte: new Date().toISOString() },
            });
            break;

          case "No apto":
            filters["$and"].push({
              revisiones: {
                active: true,
                estado: { $eq: "no_apto" },
              },
            });
            break;

          case "Caducado":
            filters["$and"].push({
              fecha_prox_revision: { $lte: new Date().toISOString() },
            });
            break;

          case "Con incidencia":
            filters["$and"].push({
              incidencias: {
                estado_incidencia: {
                  descripcion: { $eq: "abierta" },
                },
              },
            });
            break;

          case "Prox_Rev":
            filters["$and"].push(
              { fecha_prox_revision: { $gt: new Date().toISOString() } },
              {
                fecha_prox_revision: {
                  $lt: moment(new Date()).add(3, "months").toISOString(),
                },
              }
            );
            break;

          default:
            break;
        }
      }

      filters["$and"].push({
        modelo: {
          division: {
            id: { $eq: 1 },
          },
        },
      });

      // EXTENSIÓN GRADUAL: Aplicar filtros de múltiples plantas si el modo está activo
      // Esto solo modifica los filtros si modoMultiPlanta está activo, sin afectar la lógica existente
      filters = this.configurarFiltrosMultiPlanta(filters);

      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filters: filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };

      try {
        // Llamada a la API
        await this.$store.dispatch("activos/list", params).then(() => {
          this.activos = this.$store.getters["activos/list"];
          this.total = this.$store.getters["activos/listTotal"];
          if (this.total > this.totalActivos) {
            this.totalActivos = this.total;
          }

          // Controlar el estado del loading y mostrar el mensaje si no hay resultados
          this.loadingTable = false;
          this.fullscreenLoading = false;

          /*   if (this.activos.length === 0) {
            this.$notify({
              type: "info",
              message:
                "No hay ningún equipo que cumpla con los requisitos de búsqueda.",
            });
          } */
        });
      } catch (error) {
        console.error("Error al obtener la lista de activos:", error);
        this.loadingTable = false;
        this.fullscreenLoading = false;
        this.$notify({
          type: "danger",
          message: "Hubo un error al obtener la lista de equipos.",
        });
      }

      // Actualizar estadísticas usando los nuevos filtros
      await this.getStats(empresas);
    },

    // Nueva función para actualizar estadísticas
    async getStats(empresas) {
      // Incluir también equipos con fin_vida_util_alcanzada en las estadísticas
      var filtersFinVidaUtilAlcanzada = {
        $and: [
          {
            empresa: {
              id: { $in: empresas },
            },
          },
          {
            $or: [
              { retirado: 0 },
              { retirado: { $null: true } },
            ],
          },
          {
            modelo: {
              division: {
                id: { $eq: 1 },
              },
            },
          },
          {
            fin_vida_util_alcanzada: true,
          },
        ],
      };
      await this.$store
        .dispatch("activos/list", { filters: filtersFinVidaUtilAlcanzada })
        .then(() => {
          this.totalFinVidaUtilAlcanzada = this.$store.getters["activos/listTotal"];
        });

      // NO_APTO: MIRO SOLO ESTADO DE LA REVISIÓN ES no_apto.
      var filtersNoApto = {
        $and: [
          {
            empresa: {
              id: { $in: empresas },
            },
          },
          {
            $or: [
              { retirado: 0 }, // Equipos con 'retirado' igual a 0
              { retirado: { $null: true } }, // Equipos con 'retirado' igual a null
            ],
          },
          {
            modelo: {
              division: {
                id: { $eq: 1 },
              },
            },
          },
          {
            revisiones: {
              active: true,
              estado: { $eq: "no_apto" },
            },
          },
        ],
      };
      await this.$store
        .dispatch("activos/list", { filters: filtersNoApto })
        .then(() => {
          this.totalNoAptos = this.$store.getters["activos/listTotal"];
        });

      // Apto: revisión con estado APTO + fecha_prox_revision > hoy
      var filtersApto = {
        $and: [
          {
            empresa: {
              id: { $in: empresas },
            },
          },
          {
            $or: [
              { retirado: 0 }, // Equipos con 'retirado' igual a 0
              { retirado: { $null: true } }, // Equipos con 'retirado' igual a null
            ],
          },
          {
            modelo: {
              division: {
                id: { $eq: 1 },
              },
            },
          },
          {
            revisiones: {
              active: true,
              estado: { $eq: "apto" },
            },
          },
          { fecha_prox_revision: { $gte: new Date().toISOString() } },
        ],
      };
      await this.$store
        .dispatch("activos/list", { filters: filtersApto })
        .then(() => {
          this.totalAptos = this.$store.getters["activos/listTotal"];
        });

      // Apto a vigilar: revisión con estado APTO_A_VIGILAR + fecha_prox_revision > hoy
      var filtersAptoAVigilar = {
        $and: [
          {
            empresa: {
              id: { $in: empresas },
            },
          },
          {
            $or: [
              { retirado: 0 }, // Equipos con 'retirado' igual a 0
              { retirado: { $null: true } }, // Equipos con 'retirado' igual a null
            ],
          },
          {
            modelo: {
              division: {
                id: { $eq: 1 },
              },
            },
          },
          {
            revisiones: {
              active: true,
              estado: { $eq: "apto_a_vigilar" },
            },
          },
          { fecha_prox_revision: { $gte: new Date().toISOString() } },
        ],
      };
      await this.$store
        .dispatch("activos/list", { filters: filtersAptoAVigilar })
        .then(() => {
          this.totalAptosAVigilar = this.$store.getters["activos/listTotal"];
        });

      // Revisión caducada: fecha_prox_revision < hoy
      var filtersCaducadas = {
        $and: [
          {
            empresa: {
              id: { $in: empresas },
            },
          },
          {
            $or: [
              { retirado: 0 }, // Equipos con 'retirado' igual a 0
              { retirado: { $null: true } }, // Equipos con 'retirado' igual a null
            ],
          },
          {
            modelo: {
              division: {
                id: { $eq: 1 },
              },
            },
          },
          { fecha_prox_revision: { $lt: new Date().toISOString() } },
        ],
      };
      await this.$store
        .dispatch("activos/list", { filters: filtersCaducadas })
        .then(() => {
          this.totalCaducados = this.$store.getters["activos/listTotal"];
        });

      // Revisión próxima: aptos que caducan en tres meses
      var filtersProxRev = {
        $and: [
          {
            empresa: {
              id: { $in: empresas },
            },
          },
          {
            $or: [
              { retirado: 0 }, // Equipos con 'retirado' igual a 0
              { retirado: { $null: true } }, // Equipos con 'retirado' igual a null
            ],
          },
          {
            modelo: {
              division: {
                id: { $eq: 1 },
              },
            },
          },
          {
            revisiones: {
              active: true,
              estado: { $eq: "apto" },
            },
          },
          { fecha_prox_revision: { $gt: new Date().toISOString() } },
          {
            fecha_prox_revision: {
              $lt: moment(new Date()).add(3, "months").toISOString(),
            },
          },
        ],
      };
      await this.$store
        .dispatch("activos/list", { filters: filtersProxRev })
        .then(() => {
          this.totalCaducan = this.$store.getters["activos/listTotal"];
        });
    },

    /* EXPORTACIÓN EXCEL */
    async fetchDataAndExportToExcel() {
      try {
        this.loading = true;
        
        let activos = [];
        
        // Si estamos en modo multi-planta, exportar las plantas seleccionadas
        if (this.modoMultiPlanta && this.plantasParaFiltrar.length > 0) {
          // Obtener IDs válidos: filtrar "all" y valores no numéricos, y asegurar que tenemos IDs reales
          let plantasIds = this.plantasParaFiltrar
            .filter(id => id !== 'all' && id !== null && id !== undefined)
            .map(id => typeof id === 'string' ? parseInt(id) : id)
            .filter(id => !isNaN(id) && id > 0);
          
          // Si plantasSeleccionadas incluye "all", obtener todos los IDs disponibles
          if (this.plantasSeleccionadas.includes('all')) {
            const user = this.user || this.$store?.getters?.["profile/me"] || null;
            const esSalvadorSeguridad = user && user.empresas && user.empresas.some(
              empresa => empresa.id_cliente_erp === "00001001"
            );
            
            if (esSalvadorSeguridad) {
              // Para usuarios de Salvador Seguridad, cargar TODAS las empresas del sistema
              if (this.todasLasEmpresas.length === 0) {
                await this.fetchAllEmpresas();
              }
              plantasIds = this.todasLasEmpresas.map(e => e.id);
            } else if (user && user.empresas) {
              // Para otros usuarios, usar solo sus empresas asignadas
              plantasIds = user.empresas.map(e => e.id);
            }
          }
          
          // Validar que tenemos IDs válidos
          if (plantasIds.length === 0) {
            this.$notify({
              type: "warning",
              message: "No se encontraron plantas válidas para exportar.",
            });
            this.loading = false;
            return;
          }
          
          const totalPlantas = plantasIds.length;
          
          console.log('📊 Exportando múltiples plantas:', plantasIds);
          
          // Inicializar y mostrar diálogo de progreso
          this.exportProgress = 0;
          this.exportCurrentPlant = 0;
          this.exportTotalPlants = totalPlantas;
          this.exportCurrentPlantName = '';
          this.dialogProgressVisible = true;
          
          // Obtener activos de cada planta seleccionada con progreso
          for (let i = 0; i < plantasIds.length; i++) {
            const plantaId = plantasIds[i];
            
            // Validar que el ID sea un número válido antes de hacer la petición
            if (isNaN(plantaId) || plantaId <= 0) {
              console.warn(`⚠️ ID de planta inválido omitido: ${plantaId}`);
              continue;
            }
            
            try {
              // Obtener nombre de la planta para mostrar en el progreso ANTES de hacer la petición
              const planta = this.availableEmpresas.find(e => e.id === plantaId);
              this.exportCurrentPlantName = planta ? (planta.alias || planta.nombre || `Planta ${plantaId}`) : `Planta ${plantaId}`;
              
              // Mostrar progreso inicial antes de la petición
              this.exportCurrentPlant = i + 1;
              this.exportProgress = Math.round((i / totalPlantas) * 85);
              
              const response = await axios.get(
                `https://misepis-api.delfromsoftware.com/api/activos-list?idEmpresa=${plantaId}`
              );
              
              if (response.data && response.data.activos) {
                activos = activos.concat(response.data.activos);
              }
              
              // Actualizar progreso después de cada petición completada
              // El 85% del progreso se dedica a obtener datos, el 15% restante a formatear y generar Excel
              this.exportCurrentPlant = i + 1;
              this.exportProgress = Math.round(((i + 1) / totalPlantas) * 85);
              
            } catch (error) {
              console.error(`Error obteniendo activos de planta ${plantaId}:`, error);
              // Actualizar progreso incluso si hay error
              this.exportCurrentPlant = i + 1;
              this.exportProgress = Math.round(((i + 1) / totalPlantas) * 85);
            }
          }
          
          // Procesar formato de datos con progreso
          this.exportProgress = 88;
          this.exportCurrentPlantName = 'Formateando datos...';
          
          // Filtrar solo activos con división EPIS (id === 1)
          const epis = activos.filter((item) => item.modelo?.division?.id === 1);
          
          if (epis.length === 0) {
            this.dialogProgressVisible = false;
            this.$notify({
              type: "warning",
              message: "No se encontraron activos EPIS para exportar.",
            });
            return;
          }
          
          const formattedData = this.formatData(epis);
          
          // Generar Excel con progreso
          this.exportProgress = 95;
          this.exportCurrentPlantName = 'Generando archivo Excel...';
          
          await this.exportToExcel(formattedData);
          
          // Completar progreso
          this.exportProgress = 100;
          this.exportCurrentPlantName = 'Exportación completada';
          
          // Cerrar automáticamente después de 2 segundos
          setTimeout(() => {
            this.dialogProgressVisible = false;
            this.exportProgress = 0;
            this.exportCurrentPlant = 0;
            this.exportTotalPlants = 0;
            this.exportCurrentPlantName = '';
          }, 2000);
          
        } else {
          // Exportar solo la planta actual (comportamiento original)
          const planta = localStorage.getItem("plantaSelected");
          
          // Validar que la planta no sea "all"
          if (planta === 'all' || !planta || isNaN(parseInt(planta))) {
            // Si es "all", obtener todas las plantas disponibles
            await this.$store.dispatch("profile/me");
            const profile = await this.$store.getters["profile/me"];
            const perteneceSalvador = profile.empresas.some(
              empresa => empresa.id_cliente_erp === "00001001"
            );
            
            let plantasIds = [];
            if (perteneceSalvador) {
              // Para usuarios de Salvador Seguridad, cargar TODAS las empresas del sistema
              if (this.todasLasEmpresas.length === 0) {
                await this.fetchAllEmpresas();
              }
              plantasIds = this.todasLasEmpresas.map(e => e.id);
            } else if (profile.empresas) {
              // Para otros usuarios, usar solo sus empresas asignadas
              plantasIds = profile.empresas.map(e => e.id);
            }
            
            if (plantasIds.length === 0) {
              this.$notify({
                type: "warning",
                message: "No se encontraron plantas válidas para exportar.",
              });
              this.loading = false;
              return;
            }
            
            // Exportar múltiples plantas
            let todosActivos = [];
            for (const plantaId of plantasIds) {
              try {
                const response = await axios.get(
                  `https://misepis-api.delfromsoftware.com/api/activos-list?idEmpresa=${plantaId}`
                );
                if (response.data && response.data.activos) {
                  todosActivos = todosActivos.concat(response.data.activos);
                }
              } catch (error) {
                console.error(`Error obteniendo activos de planta ${plantaId}:`, error);
              }
            }
            
            const epis = todosActivos.filter((item) => item.modelo?.division?.id === 1);
            if (epis.length === 0) {
              this.$notify({
                type: "warning",
                message: "No se encontraron activos EPIS para exportar.",
              });
              return;
            }
            
            const formattedData = this.formatData(epis);
            await this.exportToExcel(formattedData);
            return;
          }
          
          // Planta específica válida
          const plantaId = parseInt(planta);
          const response = await axios.get(
            `https://misepis-api.delfromsoftware.com/api/activos-list?idEmpresa=${plantaId}`
          );

          const activos = response.data.activos;

          // Filtrar solo activos con división EPIS (id === 1)
          const epis = activos.filter((item) => item.modelo?.division?.id === 1);
          console.log("EPIS: ", epis);

          if (activos.length === 0) {
            this.$notify({
              type: "warning",
              message: "No se encontraron activos EPIS para exportar.",
            });
            return;
          }

          const formattedData = this.formatData(epis);
          await this.exportToExcel(formattedData);
        }

        console.log('📊 Total activos exportados:', activos.length);
      } catch (error) {
        console.error("Error fetching data:", error);
        this.dialogProgressVisible = false;
        this.$notify({
          type: "danger",
          message: "Error al exportar los datos.",
        });
      } finally {
        this.loading = false;
      }
    },

    async fetchSelectedAndExportToExcel() {
      try {
        this.loading = true;

        // Verificar si hay activos seleccionados
        if (this.multipleSelection.length === 0) {
          this.$notify({
            type: "warning",
            message: "No hay activos seleccionados.",
          });
          return;
        }

        // Obtener IDs de los activos seleccionados
        const selectedIds = this.multipleSelection.map((item) => item.id);

        // Cargar todos los activos de la planta
        const planta = localStorage.getItem("plantaSelected");
        
        // Validar que la planta no sea "all"
        if (planta === 'all' || !planta || isNaN(parseInt(planta))) {
          this.$notify({
            type: "warning",
            message: "No se puede exportar seleccionados cuando 'Todas las plantas' está seleccionado. Por favor, seleccione una planta específica.",
          });
          this.loading = false;
          return;
        }
        
        const plantaId = parseInt(planta);
        const response = await axios.get(
          `https://misepis-api.delfromsoftware.com/api/activos-list?idEmpresa=${plantaId}`
        );

        const activos = response.data.activos;

        // Filtrar solo los activos seleccionados
        const selectedActivos = activos.filter((item) =>
          selectedIds.includes(item.id)
        );

        // Formatear datos
        const formattedData = this.formatData(selectedActivos);

        // Exportar a Excel
        await this.exportToExcel(formattedData);
      } catch (error) {
        console.error("Error exporting selected data:", error);
      } finally {
        this.loading = false;
      }
    },

    formatData(data) {
      return data.map((item) => {
        const hoy = moment();

        // Fecha de próxima revisión
        const fechaProximaRevision = item.fecha_prox_revision
          ? moment(item.fecha_prox_revision).toDate() // Devuelve Date
          : null;

        // Fecha de última revisión (1 año atrás)
        const fechaUltimaRevision = fechaProximaRevision
          ? moment(fechaProximaRevision).subtract(1, "years").toDate()
          : null;

        // Fecha de fabricación
        const fechaFabricacion = item.fecha_fabricacion
          ? moment(item.fecha_fabricacion).toDate()
          : null;

        // Fecha de puesta en servicio
        const fechaPuestaServicio = item.fecha_adquisicion
          ? moment(item.fecha_adquisicion).toDate()
          : null;

        const fechaFinVidaUtil = formatFinVidaUtilValue(item);

        // Obtener la última revisión primero
        const ultimaRevision =
          item.revisiones?.length > 0
            ? item.revisiones[item.revisiones.length - 1]
            : null;
        
        // Determinar el estado basándose en la fecha y la última revisión
        let estadoUltimaRevision = "Indefinido";
        
        if (fechaProximaRevision) {
          const fechaProximaMoment = moment(fechaProximaRevision);
          
          // Si la fecha de próxima revisión es anterior a hoy → "Caducado"
          if (fechaProximaMoment.isBefore(hoy, 'day')) {
            estadoUltimaRevision = "Caducado";
          } else {
            // Si la fecha es hoy o posterior → usar el estado de la última revisión
            if (ultimaRevision && ultimaRevision.estado_revision) {
              estadoUltimaRevision = ultimaRevision.estado_revision.nombre;
            } else {
              estadoUltimaRevision = "Indefinido";
            }
          }
        } else {
          // Si no hay fecha de próxima revisión, usar el estado de la última revisión o "Indefinido"
          if (ultimaRevision && ultimaRevision.estado_revision) {
            estadoUltimaRevision = ultimaRevision.estado_revision.nombre;
          } else {
            estadoUltimaRevision = "Indefinido";
          }
        }

        // Determinar el color del precinto según la empresa
        let colorPrecinto;
        let colorHex;
        if (item.empresa?.data?.id === 68) {
          // Para UBE usar el colorMap y el nombre del color
          colorPrecinto = item.color_precinto_cliente || "-";
          colorHex = this.colorMap[item.color_precinto_cliente] || "#ccc";
        } else {
          // Para otras empresas usar el color basado en la fecha
          const year = fechaProximaRevision
            ? new Date(fechaProximaRevision).getFullYear() % 10
            : 0;
          const colorMapByYear = {
            1: { nombre: "AMARILLO", hex: "#F1C40F" },
            2: { nombre: "VERDE", hex: "#2ECC71" },
            3: { nombre: "NARANJA", hex: "#E67E22" },
            4: { nombre: "AZUL", hex: "#3498DB" },
            5: { nombre: "ROJO", hex: "#E74C3C" },
            6: { nombre: "AMARILLO", hex: "#F1C40F" },
            7: { nombre: "VERDE", hex: "#2ECC71" },
            8: { nombre: "NARANJA", hex: "#E67E22" },
            9: { nombre: "AZUL", hex: "#3498DB" },
            0: { nombre: "ROJO", hex: "#E74C3C" },
          };
          colorPrecinto = colorMapByYear[year]?.nombre || "-";
          colorHex = colorMapByYear[year]?.hex || "#ccc";
        }
        return {
          PLANTA: item.empresa?.alias || "No especificado",
          SUBTIPO: item.modelo?.subtipo?.nombre || "No especificado",
          MODELO: item.modelo?.nombre || "No especificado",
          FABRICANTE: item.modelo?.fabricante?.nombre || "No especificado",
          VIDA_UTIL: formatVidaUtilLabel(item.modelo?.vida_util),
          NUMERO_DE_SERIE: item.numero_serie || "",
          COLOR_PRECINTO: colorPrecinto,
          COLOR_HEX: colorHex,
          NUMERO_QR: item.numero_serie_qr || "",
          UBICACION: item.ubicacion || "",
          USUARIO: item.usuario
            ? `${item.usuario.nombre} ${item.usuario.apellidos}`
            : "",
          FECHA_DE_FABRICACION: fechaFabricacion,
          FECHA_PUESTA_SERVICIO: fechaPuestaServicio,
          FECHA_REVISION: fechaUltimaRevision,
          PROXIMA_REVISION: fechaProximaRevision,
          FIN_VIDA_UTIL: fechaFinVidaUtil,
          ESTADO: estadoUltimaRevision,
          PDF_REVISION: ultimaRevision?.id
            ? `https://misepis-api.delfromsoftware.com/api/revision-download/${ultimaRevision.id}`
            : "No disponible",
        };
      });
    },
    exportToExcel(data) {
      // Generar nombre del archivo según el número de plantas
      let nombreXLS = "EPIS.xlsx";
      
      if (this.modoMultiPlanta && this.plantasParaFiltrar.length > 0) {
        // Si hay múltiples plantas seleccionadas
        if (this.plantasSeleccionadas.includes('all')) {
          nombreXLS = `EPIS_TODAS_LAS_PLANTAS.xlsx`;
        } else if (this.plantasParaFiltrar.length === 1) {
          // Una sola planta seleccionada
          nombreXLS = data.length > 0 ? `EPIS_${data[0].PLANTA}.xlsx` : "EPIS.xlsx";
        } else {
          // Múltiples plantas específicas
          const plantasNombres = this.plantasParaFiltrar
            .map(id => {
              const empresa = this.availableEmpresas.find(e => e.id === id);
              return empresa ? empresa.alias : `Planta${id}`;
            })
            .join('_')
            .replace(/[^a-zA-Z0-9_]/g, '_')
            .substring(0, 50); // Limitar longitud
          nombreXLS = `EPIS_${plantasNombres}_${this.plantasParaFiltrar.length}plantas.xlsx`;
        }
      } else if (data.length > 0) {
        // Comportamiento original: una sola planta
        nombreXLS = `EPIS_${data[0].PLANTA}.xlsx`;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("EQUIPOS");

      // Definir encabezados
      worksheet.columns = [
        { header: "PLANTA", key: "PLANTA", width: 30 },
        { header: "SUBTIPO", key: "SUBTIPO", width: 30 },
        { header: "MODELO", key: "MODELO", width: 30 },
        { header: "FABRICANTE", key: "FABRICANTE", width: 15 },
        { header: "VIDA ÚTIL", key: "VIDA_UTIL", width: 10 },
        { header: "NÚMERO DE SERIE", key: "NUMERO_DE_SERIE", width: 20 },
        { header: "NÚMERO QR", key: "NUMERO_QR", width: 15 },
        { header: "COLOR PRECINTO", key: "COLOR_PRECINTO", width: 10 },
        { header: "UBICACIÓN", key: "UBICACION", width: 30 },
        { header: "USUARIO", key: "USUARIO", width: 20 },
        {
          header: "FECHA DE FABRICACIÓN",
          key: "FECHA_DE_FABRICACION",
          width: 20,
        },
        {
          header: "PUESTA EN SERVICIO",
          key: "FECHA_PUESTA_SERVICIO",
          width: 20,
        },
        { header: "FECHA REVISIÓN", key: "FECHA_REVISION", width: 20 },
        { header: "PRÓXIMA REVISIÓN", key: "PROXIMA_REVISION", width: 20 },
        { header: "FIN VIDA ÚTIL", key: "FIN_VIDA_UTIL", width: 20 },
        { header: "ESTADO", key: "ESTADO", width: 15 },
        { header: "PDF", key: "PDF_REVISION", width: 15 },
      ];

      // Estilo del encabezado
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF0070C0" },
        };
        cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
      });

      // Añadir filas
      data.forEach((item) => {
        const row = worksheet.addRow(item);

        // Aplicar formato de fecha solo a las celdas con fechas
        ["FECHA_DE_FABRICACION", "FECHA_PUESTA_SERVICIO", "FECHA_REVISION", "PROXIMA_REVISION", "FIN_VIDA_UTIL"].forEach(
          (key) => {
            const cell = row.getCell(key);
            if (cell.value instanceof Date) {
              cell.numFmt = "dd/mm/yyyy";
            }
          }
        );

        // Formato del color del precinto
        const colorCell = row.getCell("COLOR_PRECINTO");
        if (colorCell.value !== "-") {
          // Convertir el color hexadecimal a ARGB
          const hexColor = item.COLOR_HEX.replace("#", "");
          // Aplicar solo el color al texto, sin fondo
          colorCell.font = {
            color: { argb: "FF" + hexColor },
            bold: true,
          };
          // Centrar el texto
          colorCell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };
        }

        // Formato condicional de ESTADO
        const estadoCell = row.getCell("ESTADO");
        // Convertir el texto a mayúsculas
        estadoCell.value = estadoCell.value.toUpperCase();

        // Configuración común de bordes para todas las celdas de estado
        const borderStyle = {
          style: "thin",
          color: { argb: "FFD3D3D3" }, // Color gris claro típico de Excel
        };

        // Aplicar estilos según el estado
        if (estadoCell.value === "APTO") {
          estadoCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF2ECC71" }, // Verde más suave
          };
        } else if (estadoCell.value === "APTO, A VIGILAR.") {
          estadoCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFE67E22" }, // Naranja
          };
        } else if (["NO APTO", "CADUCADO"].includes(estadoCell.value)) {
          estadoCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFE74C3C" }, // Rojo
          };
        }

        // Aplicar formato común para todos los estados
        if (
          ["APTO", "NO APTO", "CADUCADO", "APTO, A VIGILAR."].includes(
            estadoCell.value
          )
        ) {
          estadoCell.font = {
            color: { argb: "FFFFFFFF" }, // Texto en blanco
            bold: true,
          };
          estadoCell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          // Aplicar bordes
          estadoCell.border = {
            top: borderStyle,
            left: borderStyle,
            bottom: borderStyle,
            right: borderStyle,
          };
        }

        // PDF_REVISION como enlace
        const pdfCell = row.getCell("PDF_REVISION");
        if (pdfCell.value && pdfCell.value !== "No disponible") {
          pdfCell.value = {
            text: "Descargar",
            hyperlink: pdfCell.value,
          };
          pdfCell.font = { color: { argb: "FF0000FF" }, underline: true };
        }
      });

      // Generar y descargar el archivo
      workbook.xlsx
        .writeBuffer()
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, nombreXLS);
        })
        .catch((err) => console.error("Error generating Excel file:", err));
    },
    exportSelectedToExcel() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          type: "warning",
          message: "No hay activos seleccionados.",
        });
        return;
      }

      // Formatea y exporta solo los activos seleccionados
      const formattedData = this.formatData(this.multipleSelection);
      this.exportToExcel(formattedData);
    },

    async deleteTipo(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default empresa.",
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: `Eliminar este equipo?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "No, mantenerlo",
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        if (confirmation.value === true) {
          await this.$store.dispatch("activos/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Equipo eliminado correctamente.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "This Empresa still has associated Items.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
    addDays(result, days) {
      result.setDate(result.getDate() + days);
      return result;
    },
    async getUsuarios() {
      try {
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];
        this.notificacion.usuario_origen.id = me.id;
        var meEmpresas = [];
        me.empresas.forEach((element) => {
          meEmpresas.push(element.id);
        });

        this.$store.dispatch("users/listLight").then(() => {
          var usuarios = cloneDeep(this.$store.getters["users/dropdownLight"]);

          usuarios.forEach((element) => {
            element.empresas.forEach((empresa) => {
              if (meEmpresas.includes(empresa.id)) {
                if (this.available_usuarios.length == 0) {
                  this.available_usuarios.push(element);
                }

                if (!this.checkIdRevisor(element.id)) {
                  console.log("ENTRA");
                  this.available_usuarios.push(element);
                }
              }
            });
          });
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    async getUsers() {
      this.loading = true; // Activar el loading al inicio del método
      var planta = localStorage.getItem("plantaSelected");
      console.log("PLANTA: ", planta);

      try {
        await this.$store.dispatch("profile/me");
        let profile = await this.$store.getters["profile/me"];
        this.notificacion.usuario_origen.id = profile.id;
        this.notificacion.empresa.id = planta;

        this.$store
          .dispatch("users/fetchEmpleados", {
            idEmpresa: planta,
          })
          .then(() => {
            this.available_usuarios = cloneDeep(
              this.$store.getters["users/empleados"]
            );
            console.log("USUARIOS: ", this.available_usuarios);
          });
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
        this.loading = false; // Desactivar el loading al final del método, siempre
      }
    },
    addTipo() {
      this.$router.push({ name: "Add Activo" });
    },
    async checkUserRole() {
      await this.$store.dispatch("profile/me");
      const profile = this.$store.getters["profile/me"];
      this.isRevisor = profile.empresas.some((empresa) => empresa.id === 134);
    },
    viewTipo(row) {
      console.log(row);
      this.$router.push({
        name: "View Activo",
        params: { id: row.id },
      });
    },
    editTipo(row) {
      console.log(row);
      this.$router.push({
        name: "Edit Activo",
        params: { id: row.id },
      });
    },
    sortChange({ prop, order }) {
      // Manejar columnas con propiedades anidadas
      if (prop === "usuario.data.attributes.nombre") {
        prop = "usuario.nombre"; // Transforma a una propiedad reconocida por el backend
      }

      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else if (order === "ascending") {
        this.sort = `${prop}:asc`;
      } else {
        this.sort = null; // Sin ordenación
      }

      this.getList(); // Actualizar los datos
    },

    showSwal(type) {
      if (type === "basic") {
        swal.fire({
          title: `Here's a message!`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary",
        });
      } else if (type === "info") {
        swal.fire({
          icon: "info",
          title: `Info`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info",
        });
      } else if (type === "success") {
        this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipos asignados con éxito!`,
            // text: 'Equipos entregados con éxito',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "success_devueltos") {
        this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipos devueltos con éxito!`,
            text: "Los equipos quedan disponibles para asignarlos a otro usuario.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "success_retirados") {
        this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipos retirados con éxito!`,
            text: "Los equipos han sido retirados de la circulación.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "warning") {
        swal.fire({
          title: `Warning`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning",
          icon: "warning",
        });
      } else if (type === "question") {
        swal.fire({
          title: `Are you sure?`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "question",
        });
      }
    },
    handleStateChange(value) {
      this.hasSelectedValue = !!value;
    },
    getRowClass({ row }) {
      return row.retirado ? "retired-row" : "";
    },
    
    // Formatear el porcentaje de progreso
    formatProgress(percentage) {
      return percentage === 100 ? 'Completado' : `${percentage}%`;
    },
  },
};
</script>

<style scoped>
.kpi-container {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 20px;
}


.kpi-item {
  flex: 0 0 calc((100% - 100px) / 6);
  max-width: calc((100% - 100px) / 6);
  display: flex;
}

.kpi-item .card-stats {
  width: 100%;
  min-height: 150px;
}

@media (max-width: 1400px) {
  .kpi-item {
    flex: 1 1 calc(33.333% - 20px);
    max-width: calc(33.333% - 20px);
  }
}

@media (max-width: 768px) {
  .kpi-item {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

.clear-filters-btn {
  background-color: transparent;
  border: none;
  color: #7f1058;
  font-size: 1.25rem;
}

/* Estilos para activos retirados */
.el-table .retired-row {
  opacity: 0.7;
  background-color: rgba(127, 16, 88, 0.05) !important;
}

.el-table .retired-row td {
  text-decoration: line-through;
  color: #666;
}

.el-table .retired-row .no-strike {
  text-decoration: none;
}

.el-table .retired-row .badge-retired {
  background-color: #666;
  color: white;
  text-decoration: none;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.el-table .retired-row .retired-icon {
  opacity: 0.7;
  filter: grayscale(100%);
}

/* Contenedor principal de búsqueda y filtros */
.row.col-12 {
  margin: 0;
  padding: 0;
}

/* Estilos para los componentes con filtros activos */
.has-active-filters {
  border-radius: 8px;
  margin-bottom: 0;
}

/* Estilos base para el select */
.has-filter .el-select {
  width: 100%;
}

/* Select con valor seleccionado */
.has-filter .el-select.is-selected .el-input__inner {
  background-color: #fdf2f7 !important;
  color: #7f1058 !important;
  border: 2px solid #7f1058 !important;
  font-weight: 600 !important;
}

/* Hover */
.has-filter .el-select:hover .el-input__inner {
  border-color: #7f1058 !important;
}

/* Focus/Active */
.has-filter .el-select .el-input.is-focus .el-input__inner {
  background-color: #fdf2f7 !important;
  border-color: #7f1058 !important;
  box-shadow: 0 0 0 1px #7f1058 !important;
}

/* Dropdown items */
.el-select-dropdown__item.selected {
  color: #7f1058 !important;
  font-weight: 600 !important;
  background-color: #fdf2f7 !important;
}

.el-select-dropdown__item:hover {
  background-color: #fbe5ef !important;
}

/* Datepickers */
.has-filter .datepicker {
  border: 2px solid #7f1058 !important;
  color: #7f1058 !important;
  font-weight: 600 !important;
}

.has-filter .datepicker:hover {
  background-color: #fdf2f7 !important;
}

/* Input focus states */
.has-filter .form-group .input-group.focused .form-control {
  border-color: #7f1058 !important;
  box-shadow: 0 0 0 1px #7f1058 !important;
}



.fin-vida-util-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 0;
}

.fin-vida-util-icon img,
.fin-vida-util-icon .badge-fin-vida-util {
  margin: 0;
}

.badge-fin-vida-util {
  background-color: #000;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.2em 0.4em;
  border-radius: 0.2rem;
  white-space: nowrap;
  line-height: 1;
}

.badge-fin-vida-util-inline {
  background-color: #000;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.15em 0.35em;
  border-radius: 0.2rem;
  white-space: nowrap;
}

/* Estilos para el diálogo de progreso de exportación */
.export-progress-container {
  padding: 20px;
  text-align: center;
}

.export-progress-container h5 {
  margin-bottom: 20px;
  color: #333;
  font-weight: 600;
}

.export-progress-container .el-progress {
  margin: 20px 0;
}

.export-progress-container .text-muted {
  color: #909399;
  font-size: 0.9rem;
}

.export-progress-container strong {
  color: #409eff;
  font-weight: 600;
}
</style>
